import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import { useDialog, useRequestState } from '@app/hooks';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { ILeaveManagement } from '../type';
import { AddLeaveDays } from './add-leave-days';
import {
  selectDeleteLeaveManagementState,
  selectUpdateLeaveManagementStatusState,
} from '../selectors';
import { deleteLeaveManagement, updateLeaveManagementStatus } from '../slice';
import { DeleteDialog } from '@app/components/dialog';

interface Props {
  row: ILeaveManagement;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const editDialog = useDialog();
  const activeInactiveDialog = useDialog();
  const dispatch = useDispatch();
  const actions = [
    { label: Strings.rowActions.edit, callback: editDialog.show },
    {
      label: Strings.common.activeInactiveTitle(row.status),
      callback: activeInactiveDialog.show,
    },
    { label: Strings.rowActions.delete, callback: deleteDialog.show },
  ];
  const { loading } = useRequestState({
    stateSelector: selectUpdateLeaveManagementStatusState,
    successMessageShown: true,
    onSuccess: activeInactiveDialog.hide,
    errorShown: true,
  });
  const { loading: deleteLeaveManagements } = useRequestState({
    stateSelector: selectDeleteLeaveManagementState,
    successMessageShown: true,
    onSuccess: deleteDialog.hide,
    errorShown: true,
  });
  const updateLeaveManagementStatusHandle = () => {
    dispatch(
      updateLeaveManagementStatus({
        row,
      })
    );
  };
  const onPressDelete = () => {
    dispatch(
      deleteLeaveManagement({
        id: row?.id,
      })
    );
  };
  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.activeInactiveTitle(row.status)}  ${
          Strings.leaveManagement.leaveManagement
        }`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.activeInactiveCaption(
          row.status,
          Strings.leaveManagement.leaveManagement
        )}
        loading={loading}
        visible={activeInactiveDialog.visible}
        onClickDelete={updateLeaveManagementStatusHandle}
        onClose={activeInactiveDialog.hide}
      />
      <DeleteDialog
        title={`${Strings.common.delete} ${Strings.sidebar.leaveManagement}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.deleteCaption(Strings.field.type)}
        loading={deleteLeaveManagements}
        visible={deleteDialog.visible}
        onClickDelete={onPressDelete}
        onClose={deleteDialog.hide}
      />
      {editDialog.visible && <AddLeaveDays open onClose={editDialog.hide} row={row} />}
    </>
  );
};

export { RowActions };
